<template>
  <div class="card border-0">
    <div class="card-body">
        <h5 class="card-title mb-4 text-secondary" id="test">{{testTitle}}</h5>
        <div v-if="Test">
            <div class="tests-group" v-for="group in Test.groups" :key="group.id">
                <QuestionComponent v-for="(question, key) in group.questions"
                                :QuestionData="question"
                                :key="key"
                                :questionId="question.question_id"
                                @question_responses="listenQResponses"
                                class="question-component"
                />
            </div>
        </div>
        <button type="submit" class="btn btn-info text-light mt-2" @click="handleSubmit">
            Submit
        </button>
    </div>
  </div>
</template>

<script>
import QuestionComponent from "./components/QuestionComponent";
import "bootstrap"

export default {
  name: 'TestComponent',
  emits: ["question_responses"],
  components: {
      QuestionComponent,
  },
  props:{
      id: Number,
      Test: Object,
  },
  methods: {
      getTest(id) {
        fetch(`${process.env.VUE_APP_BASEURI}/placement-test/` + id).then(response => { response.json().then( resp => {
            this.test = resp.data
            //   this.$data.testTitle = resp.message
        })
        }).catch(console.error)
      },
      listenQResponses : function (dataResponse) {
          this.Test.groups.forEach(group => {
              group.questions.forEach(question => {
                  if (question.question_id === dataResponse.questionId) {
                        question = dataResponse.QuestionData
                    }
              })  
          })
      },
      handleSubmit : function () {
          let fArray = []
          this.Test.groups.forEach(group => {
              group.questions.forEach(question => {
                  question.fields.forEach(field => {
                      let resp = (typeof field.response !== 'undefined') ? field.response : null
                      if (field.formType !== 'image' || field.formType !== 'audio') {
                          fArray.push({
                              field_id: field.id,
                              response: resp,
                          })
                      }
                  })
              })
          })
          fetch(`${process.env.VUE_APP_BASEURI}/placement-test/send-responses`, {
              method: 'post',
              headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({ test_id: this.Test.id, responses: fArray })
          })
              .then(response => {
                  response.json().then(resp => {
                      this.$data.testTitle = `${resp.message}: ${resp.data.percent}%`
                      this.$emit('question_responses', {placementTest: false, result: resp.data.percent})
                  })
              })

      },
      handleRegister : function(){
          this.$emit('question_responses', {placementTest: false})
      }
  },
//   created() {
//       fetch('https://alfa.smdev.ma/api/placement-test/list').then(response => response.json().then(res => {
//           this.tests = res.rows
//       }))
//   },
  data(){
    return {
        tests: [],
      testTitle: 'Placement test',
      test : [
          {
            text: 'how is that {1} choices: {2} Select : {3} other text input : {4}',
            response : null,
            category: 'Grammar',
            number: '1',
            fields: {
              1:{
                  formType : 'input',
                  response: null
              },
              4:{
                  formType : 'input',
              },
              2:{
                  formType : 'checkbox',
                  options : {
                      1 : 'choice 1',
                      2 : 'choice 2',
                      3 : 'choice 3',
                  },
              },
              3:{
                  formType : 'select',
                  options : {
                      1 : 'Selected 1',
                      2 : 'Selected 2',
                      3 : 'Selected 3',
                  },
              }
            },
          },
          {
              text: 'how is that {1} and image {2}',
              response : null,
              category: 'Grammar',
              number: '2',
              fields: {
                  1:{
                      formType : 'input',
                  },
                  2:{
                      formType : 'image',
                      options : {
                          url : 'https://www.alfaskolen.no/resources/img/headers/alfaskolen-logo.jpg'
                      }
                  }
              },
          },
          {
              text: 'how is that {1} an audio is : {2}',
              response : null,
              category: 'Grammar',
              number: '3',
              fields: {
                  1:{
                      formType : 'input',
                  },
                  2:{
                      formType : 'audio',
                      options: {
                          url : 'https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_700KB.mp3'
                      }
                  }
              },
          },
          {
              text: 'how is that {1}',
              response : null,
              category: 'Grammar',
              number: '4',
              fields: {
                  1:{
                      formType : 'input',
                  }
              },
          },
      ]
    }
  }
}
</script>

<style scoped src="./assets/bootstrap.min.css"></style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
  h1 {
    text-align: left;
  }
</style>
